import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import cdrFilesService from '../../services/cdrFilesService';
import { useParams, useNavigate } from 'react-router-dom';
import useRoles from '../../hooks/useRoles';

const ItemDetail = () => {
  const { id: itemId } = useParams(); // Получаем id элемента из URL
  const { hasRole } = useRoles();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [cdrfiles, setCdrfiles] = useState([]); // Массив cdrfiles
  const [mainCdrfile, setMaincdrfile] = useState(null); // Последний cdrfile
  const [file, setFile] = useState(null); // Файл для загрузки
  const [error, setError] = useState(''); // Ошибки при загрузке файла
  //const [imageUrl, setImageUrl] = useState(''); // URL изображения PNG
  const [qrCodes, setQrCodes] = useState([]); // Массив QR-кодов
  const [qrCodeImages, setQrCodeImages] = useState({}); // Объект для хранения URL изображений QR-кодов
  const [autoQr, setAutoQr] = useState(false); // <-- Состояние тумблера
  const [vectorsToBitmap, setVectorsToBitmap] = useState(false); // <-- Состояние тумблера
  const [whitePercent, setWhitePercent] = useState(0);
  const [varnishPercent, setVarnishPercent] = useState(0);
  const [dpiEnabled, setDpiEnabled] = useState(false);
  const [dpiValue, setDpiValue] = useState(500);
  const [cutBitmaps, setCutBitmaps] = useState(false);
  const [isUploading, setIsUploading] = useState(false); // Состояние загрузки
  const [uploadProgress, setUploadProgress] = useState(0); // Прогресс загрузки
  const [isModifying, setIsModifying] = useState(false); // Состояние редактирования

  const fetchItem = async () => {
    try {
      const itemResp = await api.get(`/items/${itemId}`);
      if (itemResp.data) {
        setItem(itemResp.data);
        fetchMainCdrfile(itemResp.data.id);
        fetchAllCdrfiles(itemResp.data.id);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMainCdrfile = async (itemId) => {
    try {
      const cdrfileResp = await cdrFilesService.get(`/cdrfiles/${itemId}`);
      if (cdrfileResp.data){
        setMaincdrfile(cdrfileResp.data);
        setWhitePercent(cdrfileResp.data.whitePercent);
        setVarnishPercent(cdrfileResp.data.varnishPercent);
        setDpiValue(cdrfileResp.data.dpi);
        setCutBitmaps(cdrfileResp.data.cutBitmaps);
        //setDpiEnabled(cdrfileResp.data.dpiEnabled);
        //setVectorsToBitmap(cdrfileResp.data.vectorsToBitmap);
        //setAutoQr(cdrfileResp.data.autoQr);
        //fetchImage(cdrfileResp.data.imageId)
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAllCdrfiles = async (itemId) => {
    try {
      const cdrfilesResp = await cdrFilesService.get(`/cdrfiles/${itemId}/all`);
      if (cdrfilesResp.data){
        setCdrfiles(cdrfilesResp.data.elements);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // const fetchImage = async (imageId) => {
  //   try {
  //     const response = await cdrFilesService.get(`/PngFiles/${imageId}`, {
  //       responseType: 'blob',
  //     });
  //     const url = URL.createObjectURL(response.data);
  //     setImageUrl(url);
  //   } catch (err) {
  //     console.error('Ошибка при загрузке изображения:', err);
  //   }
  // };

  // Загрузка данных элемента
  useEffect(() => {
    fetchItem();
  }, [itemId]);

  // Загрузка изображения QR-кода с использованием POST
  const fetchQrCodeImage = async (qrCodeId) => {
    try {
      const response = await api.post(
        '/qrcode/image', // Эндпоинт для получения QR-кода
        { qrCodeId }, // Передаем qrCodeId в теле запроса
        { responseType: 'blob' } // Указываем, что ожидаем бинарные данные
      );
      const url = URL.createObjectURL(response.data);
      setQrCodeImages(prev => ({ ...prev, [qrCodeId]: url }));
    } catch (err) {
      console.error('Ошибка при загрузке QR-кода:', err);
    }
  };

  // Удаление товара
  const handleDelete = async () => {
    const confirmDelete = window.confirm('Вы уверены, что хотите удалить этот товар?');
    if (confirmDelete) {
      try {
        await api.delete(`/items/${itemId}`);
        navigate('/items'); // Перенаправляем на страницу списка
      } catch (err) {
        console.error(err);
      }
    }
  };

  // Обработка загрузки файла
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (!selectedFile.name.endsWith('.cdr')) {
        setError('Файл должен иметь расширение .cdr');
        return;
      }
      setFile(selectedFile);
      setError('');
    }
  };

  // Загрузка файла на сервер
  const handleFileUpload = async () => {
    if (!file) {
      setError('Файл не выбран');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    const queryParams = new URLSearchParams();
    queryParams.append('qr', autoQr);
    queryParams.append('wp', whitePercent);
    queryParams.append('vp', varnishPercent);
    queryParams.append('vtb', vectorsToBitmap);
    if (dpiEnabled) {
      queryParams.append('dpi', dpiValue);
    }
    queryParams.append('cb', cutBitmaps);

    try {
      setIsUploading(true);
      setUploadProgress(0);

      await cdrFilesService.post(`/cdrfiles/${itemId}/upload?${queryParams.toString()}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        }
      });

      setFile(null);
      setError('');
      fetchMainCdrfile(itemId);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Ошибка загрузки файла');
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  // Редактирование файла на сервере
  const handleFileModify = async () => {
    const formData = new FormData();
    
    const queryParams = new URLSearchParams();
    queryParams.append('qr', autoQr);
    queryParams.append('wp', whitePercent);
    queryParams.append('vp', varnishPercent);
    queryParams.append('vtb', vectorsToBitmap);
    if (dpiEnabled) {
      queryParams.append('dpi', dpiValue);
    }
    queryParams.append('cb', cutBitmaps);

    try {
      setIsModifying(true);

      await cdrFilesService.patch(`/cdrfiles/${itemId}/modify?${queryParams.toString()}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setError('');
      fetchMainCdrfile(itemId);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Ошибка редактирования файла');
    } finally {
      setIsModifying(false);
    }
  };

  // Скачивание файла
  const handleDownload = async (file) => {
    if (file) {
        const response = await cdrFilesService.get(`/cdrfiles/${itemId}/download/${file.id}`, {responseType: 'blob'}); // Замените на ваш URL
        
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: "application/octet-stream" });

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary <a> element to trigger the download
        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.download = `${item.article}.cdr`;// Set the desired filename for the downloaded file

        // Append the <a> element to the body and click it to trigger the download
        document.body.appendChild(tempLink);
        tempLink.click();

        // Clean up the temporary elements and URL
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
    } else {
      alert('No file attached.');
    }
  };

  // Добавление нового QR-кода
  const handleAddQrCode = async () => {
    try {
      await api.post(`/qrcode/create/${itemId}`);
      // Обновляем данные элемента после добавления QR-кода
      const res = await api.get(`/items/${itemId}`);
      setItem(res.data);
      if (res.data.qrCodes) {
        setQrCodes(res.data.qrCodes);
        // Загружаем изображение для нового QR-кода
        const newQrCode = res.data.qrCodes[res.data.qrCodes.length - 1];
        fetchQrCodeImage(newQrCode.id);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Удаление QR-кода
  const handleDeleteQrCode = async (qrCodeId) => {
    const confirmDelete = window.confirm('Вы уверены, что хотите удалить этот QR-код?');
    if (confirmDelete) {
      try {
        await api.delete(`/qrcode/${qrCodeId}`);
        // После удаления обновляем данные
        const res = await api.get(`/items/${itemId}`);
        setItem(res.data);
        if (res.data.qrCodes) {
          setQrCodes(res.data.qrCodes);
          // Перезагрузим QR-изображения
          res.data.qrCodes.forEach(qrCode => {
            fetchQrCodeImage(qrCode.id);
          });
        }
      } catch (err) {
        console.error('Ошибка при удалении QR-кода:', err);
      }
    }
  };

  // Удаление макета
  const handleDeleteFile = async (file) => {
    const confirmDelete = window.confirm('Вы уверены, что хотите удалить этот файл?');
    if (confirmDelete) {
      try {
        await cdrFilesService.delete(`/cdrfiles/${itemId}/delete/${file.id}`);
      } catch (err) {
        console.error(err);
      }
    }
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

  if (!item) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mt-4">
      {/* Информация о элементе */}
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col">
              {/* Отображение изображения PNG */}
              {mainCdrfile && (
                <div className="m-3">
                  <img src={cdrFilesService.getCdrfilePreview(mainCdrfile.imageId)} alt="Attached PNG" style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
              )}
            </div>
            <div className="col">
              <h2 className="card-title">{item.name}</h2>
              <p className="card-text">
                <strong>Категория:</strong> {item.category?.name}
              </p>
              <p className="card-text">
                <strong>Материал:</strong> {item.material?.name}
              </p>
              <p className="card-text">
                <strong>Размеры:</strong> {item.widthInCm}см (Ш) x {item.heightInCm}см (В) x {item.depthInCm}см (Т)
              </p>
              <p className="card-text">
                <strong>Объем:</strong> {item.volumeInCm3} см³
              </p>
              <p className="card-text">
                <strong>Время создания:</strong> {new Date(item.creationTime).toLocaleString()} {item.createdBy}
              </p>
              <p className="card-text">
                <strong>Время обновления:</strong> {new Date(item.updateTime).toLocaleString()} {item.updatedBy}
              </p>
              <p className="card-text">
                <strong>Артикул:</strong> {item.article}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Кнопки для редактирования, удаления и скачивания файла */}
      <div className="mt-3">
        {hasRole('DownloadCdr') && mainCdrfile && (
          <button className="btn btn-success me-2" onClick={() => handleDownload(mainCdrfile)}>
            Скачать макет
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download ms-1" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"></path>
            </svg>
          </button>
        )}
        {hasRole('UpdateItem') && (
            <button
              className="btn btn-warning me-2"
              onClick={() => navigate(`/items/${itemId}/edit`)}
            >
              Редактировать
            </button>
        )}
        {hasRole('DeleteItem') && (
          <button className="btn btn-danger me-2" onClick={handleDelete}>
            Удалить
          </button>
        )}
        
      </div>

      {/* Drag-and-drop загрузка файла */}
      {hasRole('UploadCdr') && (
        <div className="mt-4">
          <div className="accordion" id="uploadAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingUpload">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseUpload"
                  aria-expanded="false"
                  aria-controls="collapseUpload"
                >
                  Загрузка макета
                </button>
              </h2>
              <div
                id="collapseUpload"
                className="accordion-collapse collapse"
                aria-labelledby="headingUpload"
                data-bs-parent="#uploadAccordion"
              >
                <div className="accordion-body">
                  <input
                    type="file"
                    accept=".cdr"
                    onChange={handleFileChange}
                    className="form-control"
                  />

                  {/* Ползунок Процент белого */}
                  <div className="mt-3">
                    <label htmlFor="whitePercentRange" className="form-label">
                      Процент белого: {whitePercent}%
                    </label>
                    <input
                      type="range"
                      className="form-range"
                      id="whitePercentRange"
                      min="0"
                      max="100"
                      step="5"
                      value={whitePercent}
                      onChange={(e) => setWhitePercent(parseInt(e.target.value))}
                    />
                  </div>

                  {/* Ползунок Процент лака */}
                  <div className="mt-3">
                    <label htmlFor="varnishPercentRange" className="form-label">
                      Процент лака: {varnishPercent}%
                    </label>
                    <input
                      type="range"
                      className="form-range"
                      id="varnishPercentRange"
                      min="0"
                      max="100"
                      step="5"
                      value={varnishPercent}
                      onChange={(e) => setVarnishPercent(parseInt(e.target.value))}
                    />
                  </div>

                  {/* Toggle для autoQr */}
                  <div className="form-check form-switch mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="autoQrToggle"
                      checked={autoQr}
                      onChange={() => setAutoQr(!autoQr)}
                    />
                    <label className="form-check-label" htmlFor="autoQrToggle">
                      Автоматически размещать QR
                    </label>
                  </div>

                  {/* Toggle для vectorsToBitmap */}
                  <div className="form-check form-switch mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="vectorsToBitmapToggle"
                      checked={vectorsToBitmap}
                      onChange={() => setVectorsToBitmap(!vectorsToBitmap)}
                    />
                    <label className="form-check-label" htmlFor="vectorsToBitmapToggle">
                      Преобразовать вектора в растр
                    </label>
                  </div>

                  {/* Тумблер Обрезка растров */}
                  <div className="form-check form-switch mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="cutBitmapsToggle"
                      checked={cutBitmaps}
                      onChange={() => setCutBitmaps(!cutBitmaps)}
                    />
                    <label className="form-check-label" htmlFor="cutBitmapsToggle">
                      Обрезать растры по контуру
                    </label>
                  </div>

                  {/* Новый тумблер DPI */}
                  <div className="d-flex align-items-center mt-3">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="dpiToggle"
                        checked={dpiEnabled}
                        onChange={() => setDpiEnabled(!dpiEnabled)}
                      />
                      <label className="form-check-label" htmlFor="dpiToggle">
                        Уменьшить DPI (точек на дюйм)
                      </label>
                    </div>
                    <select
                      className="form-select ms-3"
                      value={dpiValue}
                      onChange={(e) => setDpiValue(parseInt(e.target.value))}
                      disabled={!dpiEnabled}
                      style={{ width: '120px' }}
                    >
                      <option value={300}>300</option>
                      <option value={400}>400</option>
                      <option value={500}>500</option>
                      <option value={600}>600</option>
                    </select>
                  </div>

                  

                  {error && <div className="text-danger mt-2">{error}</div>}

                  <button
                    className="btn btn-primary mt-3"
                    onClick={handleFileUpload}
                    disabled={!file || isUploading}
                  >
                    {isUploading ? 'Загрузка...' : 'Загрузить'}
                  </button>

                  {/* Прогресс бар */}
                  {isUploading && (
                    <div className="progress mt-3" style={{ height: '25px' }}>
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${uploadProgress}%` }}
                        aria-valuenow={uploadProgress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {uploadProgress}%
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Редактирование файла */}
      {hasRole('ModifyCdr') && mainCdrfile && (
        <div className="mt-4">
          <div className="accordion" id="modifyAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingModify">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseModify"
                  aria-expanded="false"
                  aria-controls="collapseModify"
                >
                  Редактирование макета
                </button>
              </h2>
              <div
                id="collapseModify"
                className="accordion-collapse collapse"
                aria-labelledby="headingModify"
                data-bs-parent="#modifyAccordion"
              >
                <div className="accordion-body">
                  
                  {/* Ползунок Процент белого */}
                  <div className="mt-3">
                    <label htmlFor="whitePercentRange" className="form-label">
                      Процент белого: {whitePercent}%
                    </label>
                    <input
                      type="range"
                      className="form-range"
                      id="whitePercentRange"
                      min="0"
                      max="100"
                      step="5"
                      value={whitePercent}
                      onChange={(e) => setWhitePercent(parseInt(e.target.value))}
                    />
                  </div>

                  {/* Ползунок Процент лака */}
                  <div className="mt-3">
                    <label htmlFor="varnishPercentRange" className="form-label">
                      Процент лака: {varnishPercent}%
                    </label>
                    <input
                      type="range"
                      className="form-range"
                      id="varnishPercentRange"
                      min="0"
                      max="100"
                      step="5"
                      value={varnishPercent}
                      onChange={(e) => setVarnishPercent(parseInt(e.target.value))}
                    />
                  </div>

                  {/* Toggle для autoQr */}
                  <div className="form-check form-switch mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="autoQrToggle"
                      checked={autoQr}
                      onChange={() => setAutoQr(!autoQr)}
                    />
                    <label className="form-check-label" htmlFor="autoQrToggle">
                      Автоматически размещать QR
                    </label>
                  </div>

                  {/* Toggle для vectorsToBitmap */}
                  <div className="form-check form-switch mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="vectorsToBitmapToggle"
                      checked={vectorsToBitmap}
                      onChange={() => setVectorsToBitmap(!vectorsToBitmap)}
                    />
                    <label className="form-check-label" htmlFor="vectorsToBitmapToggle">
                      Преобразовать вектора в растр
                    </label>
                  </div>

                  {/* Новый тумблер DPI */}
                  <div className="d-flex align-items-center mt-3">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="dpiToggle"
                        checked={dpiEnabled}
                        onChange={() => setDpiEnabled(!dpiEnabled)}
                      />
                      <label className="form-check-label" htmlFor="dpiToggle">
                        DPI (точек на дюйм)
                      </label>
                    </div>
                    <select
                      className="form-select ms-3"
                      value={dpiValue}
                      onChange={(e) => setDpiValue(parseInt(e.target.value))}
                      disabled={!dpiEnabled}
                      style={{ width: '120px' }}
                    >
                      <option value={300}>300</option>
                      <option value={400}>400</option>
                      <option value={500}>500</option>
                      <option value={600}>600</option>
                    </select>
                  </div>

                  {/* Тумблер Обрезка растров */}
                  <div className="form-check form-switch mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="cutBitmapsToggle"
                      checked={cutBitmaps}
                      onChange={() => setCutBitmaps(!cutBitmaps)}
                    />
                    <label className="form-check-label" htmlFor="cutBitmapsToggle">
                      Обрезка растров
                    </label>
                  </div>

                  {error && <div className="text-danger mt-2">{error}</div>}

                  <button
                    className="btn btn-primary mt-3"
                    onClick={handleFileModify}
                    disabled={isUploading || isModifying}
                  >
                    {isModifying ? 'Редактируется...' : 'Сохранить'}
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Отображение прощлых версий макетов */}
      {hasRole('DownloadCdr') && mainCdrfile && (
        <div className="mt-3">
          <div className="accordion" id="versionAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingVersions">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseVersions" aria-expanded="false" aria-controls="collapseVersions">
                  Прошлые версии
                </button>
              </h2>
              <div id="collapseVersions" className="accordion-collapse collapse" aria-labelledby="headingVersions" data-bs-parent="#versionAccordion">
                <div className="accordion-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Дата загрузки</th>
                        <th>Кем загружено</th>
                        <th>Размер</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cdrfiles && cdrfiles
                        .slice()
                        .sort((a, b) => new Date(b.uploadTime) - new Date(a.uploadTime))
                        .map((file, index) => {
                          const isCurrent = index === 0;
                          return (
                            <tr key={file.id}>
                              <td>
                                {new Date(file.uploadTime).toLocaleString()}
                                {isCurrent && <span className="badge bg-success ms-2">Текущая версия</span>}
                                {file.qrCodesCount > 0 && <span className="badge bg-primary ms-2">{file.qrCodesCount} QR-кодов</span>}
                                {file.varnishPercent > 0 && <span className="badge bg-warning text-dark ms-2">{file.varnishPercent}% лака</span>}
                                {file.whitePercent > 0 && <span className="badge bg-light text-dark ms-2">{file.whitePercent}% белого</span>}
                                {file.dpi && <span className="badge bg-info text-dark ms-2">{file.dpi} DPI</span>}
                                {file.cutBitmaps && <span className="badge bg-secondary ms-2">Растры обрезаны</span>}
                              </td>
                              <td>{file.uploadedBy}</td>
                              <td>{formatBytes(file.sizeInBytes, 2)}</td>
                              <td>
                                <button className="btn btn-sm btn-outline-primary" onClick={() => handleDownload(file)}>Скачать</button>
                              </td>
                              {hasRole('DeleteCdrFile') && (
                                <td>
                                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteFile(file)}>Удалить</button>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Отображение QR-кодов */}
      {hasRole('ReadQrCode') && qrCodes.length > 0 && (
              <div className="mt-3">
                <div className="accordion" id="qrCodesAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingQrCodes">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseQrCodes" aria-expanded="false" aria-controls="collapseQrCodes">
                        QR-коды
                      </button>
                    </h2>
                    <div id="collapseQrCodes" className="accordion-collapse collapse" aria-labelledby="headingQrCodes" data-bs-parent="#qrCodesAccordion">
                      <div className="accordion-body">
                        {qrCodes.slice()
                        .sort((a, b) => a.number - b.number)
                        .map((qrCode, index) => (
                          <div key={qrCode.id} className="mb-3">
                            
                            <div className="row">
                              <div className="col d-flex justify-content-end align-items-center"> 
                                {qrCodeImages[qrCode.id] ? (
                                <img src={qrCodeImages[qrCode.id]} alt={`QR Code ${qrCode.id}`} style={{ maxWidth: '100%', height: 'auto' }} />
                                ) : (
                                  <div>Загрузка QR-кода...</div>
                                )}
                              </div>
                              <div className="col d-flex justify-content-start align-items-center"> 
                                <p><strong>Часть {qrCode.number}</strong></p>

                                {/* Кнопка удаления QR-кода */}
                                {hasRole('DeleteQrCode') && (
                                  <button
                                    className="btn btn-sm btn-outline-danger mt-2"
                                    onClick={() => handleDeleteQrCode(qrCode.id)}
                                  >
                                    Удалить QR-код
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                        {hasRole('CreateQrCode') && (
                          <button className="btn btn-primary mt-3" onClick={handleAddQrCode}>
                          Добавить QR-код
                        </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
  </div>
  );
};

export default ItemDetail;